<template>
  <div>=
    <el-row :gutter="5">
      <el-form ref="formData"
               :model="formData"
               :rules="rules"
               label-width="100px">

        <el-form-item label="标题"
                      prop="Title"
                      style="width:700px">
          <el-input v-model="formData.Title"
                    placeholder="请输入标题" />
        </el-form-item>

        <el-form-item label="适用App"
                      prop="AppIds"
                      style="width:700px">
          <el-select v-model="formData.AppIds"
                     multiple
                     placeholder="请选择适用App">
            <el-option v-for="item in appOptions"
                       :key="item.AppId"
                       :label="item.Name"
                       :value="item.AppId">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="操作"
                      prop="Href"
                      style="width:700px">
          <el-input v-model="formData.Href"
                    placeholder="请输入操作" />
        </el-form-item>

        <el-form-item label="分类"
                      prop="Category"
                      style="width:700px">
          <el-select v-model="formData.Category"
                     placeholder="请选择分类"
                     filterable>
            <el-option v-for="item in typeList"
                       :key="item.Value"
                       :label="item.Name"
                       :value="item.Value"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="备注"
                      prop="Remark"
                      style="width:700px">
          <el-input type="textarea"
                    v-model="formData.Remark"
                    placeholder="请选择备注" />
        </el-form-item>
        <el-form-item label="状态" prop="State">
          <el-switch v-model="formData.State"  active-text="下架" inactive-text="正常"  :active-value="2"
        :inactive-value="1"  />
            </el-form-item>
        <el-form-item label="内容"
                      prop="Content"
                      style="width:700px">
          <vue-editor v-model="formData.Content" />
        </el-form-item>

        <el-col :span="20">
          <el-form-item size="large"
                        style="width:700px">
            <el-button type="primary"
                       @click="submitForm">确 定</el-button>
            <el-button @click="$router.go(-1)">返回</el-button>
          </el-form-item>
        </el-col>
      </el-form>
    </el-row>
  </div>
</template>

<script>
import { categoryNotice, editNotice, addNotice } from '@/api/notice'
import { listAppInfo } from "@/api/appInfo.js";

import { VueEditor } from 'vue2-editor'
export default {
  components: {
    VueEditor
  },
  data () {
    return {
      formData: {},
      rules: {
        Title: [
          { required: true, message: "账号不能为空", trigger: "blur" }
        ],
        AppIds: [
          { required: true, message: "适用App不能为空", trigger: "blur" }
        ],
        Href: [
          { required: true, message: "操作不能为空", trigger: "blur" }
        ],
        Category: [
          { required: true, message: "分类不能为空", trigger: "blur" }
        ],
        Content: [
          { required: true, message: "内容不能为空", trigger: "blur" }
        ]
      },
      typeList: [],
      appOptions:[]
    }
  },
  mounted () {
    this.getCategory()
    this.getAppInfo()
    if (Object.values(this.$route.query).length != []) {
      
      this.formData = { ...this.$route.query }
      this.formData.AppIds = this.formData.AppIds.split(',')
    }
  },
  methods: {
    async getAppInfo () {
      const [res, err] = await listAppInfo()
      this.appOptions = res.data.Data
      
    },
    async getCategory () {
      const [res, err] = await categoryNotice()
      this.typeList = res.data
    },
    submitForm () {
      if (!this.formData.Remark) {
        this.formData.Remark = ''
      }
      this.formData.AppIds = this.formData.AppIds.join(',')
      this.$refs.formData.validate(async (valid) => {
        if (valid) {
          if (this.formData.Id) {
            let item = JSON.parse(JSON.stringify(this.formData))
            const [res, err] = await editNotice(item)
            if (res.data.Code == 1) {
              this.$router.go(-1)
            }
          } else {
            const [res, err] = await addNotice(this.formData)
            if (res.data.Code == 1) {
              this.$router.go(-1)
            }
          }
        }

      })
    },
    cancel () {
    }
  }
}
</script>

<style scoped>
</style>